import type { ZodType } from 'zod';

/**
 * Read a JSON document from a Web Storage and validate it.
 *
 * Storage is a trust boundary (another tab, an older build or the user can
 * rewrite it), so what comes out goes through `schema`. An unreadable or invalid
 * entry is removed and reported as absent: the callers treat it as "nothing
 * stored" and the next write replaces it.
 */
export function lireJson<T>(storage: Storage, cle: string, schema: ZodType<T>): T | null {
  const brut = storage.getItem(cle);
  if (brut === null) return null;

  let valeur: unknown;
  try {
    valeur = JSON.parse(brut);
  } catch {
    // Corrupted entry: dropped below, same as a schema mismatch.
    storage.removeItem(cle);
    return null;
  }

  const resultat = schema.safeParse(valeur);
  if (!resultat.success) {
    storage.removeItem(cle);
    return null;
  }
  return resultat.data;
}

export function ecrireJson(storage: Storage, cle: string, valeur: unknown): void {
  storage.setItem(cle, JSON.stringify(valeur));
}
